import { InjectionToken } from "@angular/core";
import { BookingSessionPort } from "../ports/booking-session.port";

export const BOOKING_SESSION = new InjectionToken<BookingSessionPort>('BOOKING_SESSION');